import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_037",
  "use": "icon-su_037-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-su_037\"><defs><style>#icon-su_037 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_037_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_037_icon\"><rect class=\"cls-1\" width=\"12\" height=\"12\" /><rect class=\"cls-2\" x=\"3\" width=\"2\" height=\"12\" /><rect class=\"cls-2\" x=\"7\" width=\"2\" height=\"12\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol